import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@helpers/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@app/shell/shell.module').then((m) => m.ShellModule),
  },
  {
    path: 'home',
    redirectTo: '',
  },
  // {
  //   path: 'residential-complex/:id',
  //   loadChildren: () => import('@modules/residential-complex-details/residential-complex-details.module').then((m) => m.ResidentialComplexDetailsModule),
  // },
  {
    path: 'my-application-list',
    canActivate: [AuthGuard],
    loadChildren: () => import('@modules/my-application-list/my-application-list.module').then((m) => m.MyApplicationListModule),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadChildren: () => import('@pages/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: () => import('@modules/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'contract',
    loadChildren: () => import('@modules/electronic-signing/electronic-signing.module').then((m) => m.ElectronicSigningModule),
  },
  {
    path: 'about',
    loadChildren: () => import('@app/about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'my-application-list',
    loadChildren: () => import('@modules/my-application-list/my-application-list.module').then((m) => m.MyApplicationListModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: PreloadAllModules, initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
